
<div class="row bg-white">
	<div class="form-group col-xs-12">
		<div>{{{content}}}</div>
	</div>
</div>
